import { createApiClient } from "./client";

interface StoreLocationResponse {
  store_location: string;
}

export const cleanStoreLocationUrl = (url: string): string => {
  const withProtocol = url.startsWith("http") ? url : `https://${url}`;
  try {
    const u = new URL(withProtocol);
    u.hostname = u.hostname.replace(/^dashboard\./, "");
    return u.toString();
  } catch {
    return withProtocol;
  }
};

export const fetchStoreLocation = async (
  clientId: string,
  storeNumber: string
): Promise<StoreLocationResponse | null> => {
  try {
    const client = createApiClient();
    return await client
      .get(`locations/clients/${clientId}/stores/${storeNumber}`)
      .json<StoreLocationResponse>();
  } catch (error) {
    console.warn("Failed to fetch store location:", error);
    return null;
  }
};
